import Api from '../../../api/article/articleGroupApi'

export default {
  namespaced: true,
  state: {
    groups: [],
    assigned: []
  },
  mutations: {
    setGroups(state, data) {
      state.groups = data;
    },
    setAssigned(state, data) {
      state.assigned = data;
    }
  },
  actions: {
    add(context, { model }) {
      return new Promise((resolve, reject) => {
        Api.add(model).then(response => {
          context.dispatch('NOTIFY_MSG', 'article.notification.save',
            { root: true});
          resolve(response.data);
        }).catch(error => {
          context.dispatch('NOTIFY_ERROR', error, {root: true}).then(() => reject(error)) ;
        })
      })
    },
    update(context, { model }) {
      return new Promise((resolve, reject) => {
        Api.update(model).then(response => {
          context.dispatch('NOTIFY_MSG', 'article.notification.save',
            { root: true});
          resolve(response.data);
        }).catch(error => {
          context.dispatch('NOTIFY_ERROR', error, { root: true});
          reject(error);
        })
      })
    },
    delete(context, { id }) {
      return new Promise((resolve, reject) => {
        Api.delete(id).then(response => {
          context.dispatch('NOTIFY_MSG', 'article.notification.delete',
            { root: true});
          resolve(response.data);
        }).catch(error => {
          context.dispatch('NOTIFY_ERROR', error, { root: true});
          reject(error);
        })
      })
    },
    async fetchAll({dispatch, commit}) {
      try {
        const response = await Api.fetchAll();
        commit('setGroups', response.data);
        return Promise.resolve(response.data);
      } catch(error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async fetchAssigned({ dispatch, commit }, { articleId }) {
      try {
        const response = await Api.fetchAssigned(articleId);
        commit('setAssigned', response.data);
        return Promise.resolve(response.data);
      } catch(error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    }
  }
}
